import { render, staticRenderFns } from "./border-radius.vue?vue&type=template&id=d5a85782&"
import script from "./border-radius.vue?vue&type=script&lang=js&"
export * from "./border-radius.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports